/** Token-style placeholders shown on cover when preview context is sample/fallback (Block Library). */
export const COVER_CUSTOMER_PLACEHOLDER = '{{customer.name}}';

/** Quote date token — real quotes supply a formatted date at generate time. */
export const COVER_DATE_PLACEHOLDER = '{{quote.date}}';
